module.exports = __webpack_public_path__ + "img/version-fill.a1ba4daa.svg";